// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries
import {
  getFirestore,
  doc,
  onSnapshot,
  setDoc,
  increment,
  updateDoc,
  getDoc,
} from "firebase/firestore";
import { fromPairs, map, mapObjIndexed } from "ramda";
import { useEffect, useState } from "react";

// functions
import randomInt from "./functions/randomInt";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyAbgIWUizhIjJDhWkAl7vqXaFvozw6b6kI",
  authDomain: "rcs-realtimesales-dev.firebaseapp.com",
  projectId: "rcs-realtimesales-dev",
  storageBucket: "rcs-realtimesales-dev.appspot.com",
  messagingSenderId: "671096670925",
  appId: "1:671096670925:web:7a20103cc2f1f220c7b784",
};

const prodConfig = {
  // Your web app's Firebase configuration
  apiKey: "AIzaSyAm_9vMeXOCbJHKEW6-dPXHPNjF5rM1Xyg",
  authDomain: "rcs-realtimesales-prod.firebaseapp.com",
  projectId: "rcs-realtimesales-prod",
  storageBucket: "rcs-realtimesales-prod.appspot.com",
  messagingSenderId: "1023886411741",
  appId: "1:1023886411741:web:e40ee3d121fc9b78db9834"
}

// Initialize Firebase and Firestore
export const app = initializeApp(prodConfig);
export const db = getFirestore(app);

const setStateWithDelta = (newState, setDelta) => (state) => {
  const newDelta = mapObjIndexed((v, k) => (v - (state?.data?.[k] || 0)))(newState?.data)
  setDelta(delta => {
    if(!Object.keys(delta).length){
      return map((v, k) => 0)(newState?.data)
    }
    return mapObjIndexed((v, k) => ((newDelta?.[k] || 0) + v))(delta)
  })
  return {
    data: newState?.data,
    delta: newDelta
  }
}

function simulate(setState, keys, init = true, setDelta) {

  if (init) {
    const newMap = map((k) => [k, randomInt(10)(100)])(keys)
    const data = fromPairs(newMap)
    const newDeltaMap = map((k) => [k, 0])(keys)
    const delta = fromPairs(newDeltaMap)
    setState(setStateWithDelta({ data }, ()=>{}));
    setDelta(delta)
  }
  const i = setTimeout(() => {
    setState(state => {
      return setStateWithDelta({ data: map((value, key) => (value + randomInt(1)(3)))(state?.data) }, setDelta)(state)
    });
    simulate(setState, keys, false, setDelta)
  }, randomInt(200)(5000));
  return () => {
    clearInterval(i);
  };
}

export const useFirestoreData = (path, selectedChain = "all", keys, setDelta) => {
  const [state, setState] = useState({ loading: true, data: {} });

  useEffect(() => {
    const unsub = selectedChain !== "demo" ? getFirebaseListener(doc(db, path), selectedChain, setState, setDelta) : simulate(setState, keys, state.loading, setDelta)

    return () => {
      unsub();
    }
  }, [path]);

  return state;
};

export const increaseDemoData = (nthOption) => (path) =>
  updateDoc(doc(db, path), {
    12345: increment(nthOption === 1 ? randomInt(1)(5) : 0),
    12346: increment(nthOption === 2 ? randomInt(1)(5) : 0),
  });

export const resetDemoData = (path) =>
  setDoc(doc(db, path), {
    12345: 1,
    12346: 1,
  });
function getFirebaseListener(doc, selectedChain, setState, setDelta) {    
  return onSnapshot(doc, (doc) => {
    const data = doc.data();
    setFirebaseData(selectedChain, data, setState, setDelta);
  });
}

function setFirebaseData(selectedChain, data, setState, setDelta) {
  const { chain = selectedChain, ...rest } = (selectedChain === "all" || selectedChain === "store") ? data : data?.chain?.[selectedChain] || {};
  setState(setStateWithDelta({ data: rest || {} }, setDelta));
}

